import * as React from "react";
const IconFrameExpandCopy = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M19.3 3H4c-.6 0-1 .4-1 1v15.3c0 .6.4 1 1 1s1-.4 1-1V5h14.3c.6 0 1-.4 1-1s-.5-1-1-1M60 3H44.7c-.6 0-1 .4-1 1s.4 1 1 1H59v14.3c0 .6.4 1 1 1s1-.4 1-1V4c0-.6-.4-1-1-1M60 43.7c-.6 0-1 .4-1 1V59H44.7c-.6 0-1 .4-1 1s.4 1 1 1H60c.6 0 1-.4 1-1V44.7c0-.5-.4-1-1-1M19.3 59H5V44.7c0-.6-.4-1-1-1s-1 .4-1 1V60c0 .6.4 1 1 1h15.3c.6 0 1-.4 1-1s-.5-1-1-1" />
  </svg>
);
export default IconFrameExpandCopy;
